<template>
    <div  style="white-space: pre-wrap;" v-html="body">

    </div>
</template>
<script>
export default {
    data(){
        return{
            body:"",
            is_Ie:false
        }
    },
    mounted(){
         this.getRss()
        
       
    },
    methods:{
        getRss(){
            this.$store.dispatch('_GetRss').then(res=>{
              this.body=res.data.Data
         })
     
        }
    }
}
</script>